import React from 'react';
export function Problem() {
  return <section aria-labelledby="problema" className="w-full bg-cream" data-id="element-163" data-mp="24g1t9j391trl">
      <div className="mx-auto w-full max-w-3xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-164" data-mp="2pefrbuoc8ofy">
        <h2 id="problema" className="font-display text-[1.6rem] font-bold leading-snug text-ink sm:text-3xl lg:text-4xl" data-id="element-165" data-mp="2bg94raouaavl">
          ¿Te han negado un préstamo de auto, una tarjeta de crédito o incluso el alquiler de un
          apartamento en los últimos meses?
        </h2>

        <div className="mt-6 space-y-4 text-[1.02rem] leading-relaxed text-muted sm:mt-8 sm:space-y-6 sm:text-lg" data-id="element-166" data-mp="26gwd8cn0wfmo">
          <p data-id="element-167" data-mp="1sqj6ueps58zg">
            Esa sensación de impotencia al ver la cara del vendedor cuando “el sistema” dice que no
            eres apta es humillante.
          </p>
          <p className="border-l-2 border-gold pl-4 text-lg font-medium leading-relaxed text-ink sm:pl-6 sm:text-xl" data-id="element-168" data-mp="1irbrxn3ed6a8">
            Pero aquí está la verdad que nadie te dice: tu score no es un reflejo de quién eres, es
            simplemente un error que puedes corregir hoy mismo.
          </p>
          <p data-id="element-169" data-mp="ob3ys5s2hvfv">
            Para la mayoría de las latinas en este país, el crédito es la llave de todo. Sin un buen
            score, estás condenada a pagar intereses abusivos, a vivir en zonas que no te gustan y a
            sentir que el “Sueño Americano” es solo para otros.
          </p>
          <p data-id="element-170" data-mp="9lod347e8g71">
            Las agencias de reparación de crédito lo saben y se aprovechan de ti, cobrándote
            mensualidades de <strong className="font-semibold text-ink" data-id="element-171" data-mp="5l5jp5pur22q">$100 o $150 dólares</strong>{' '}
            por enviar cartas que tú misma podrías imprimir en 5 minutos. Ellas no quieren que
            arregles tu crédito rápido, porque si lo haces, ¡dejas de pagarles!
          </p>
        </div>
      </div>
    </section>;
}